module.exports = __webpack_public_path__ + "static/media/birdy-rush.bb579094.jpg";